import { useEffect } from 'react';
import { PermissionsResponse } from 'src/apis/authorization-service/types';
import { AuthorizationServiceRequest } from 'src/apis/authorization-service/use-authorization-service';
import { Successful, useAxios } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';
import urlTemplate from 'url-template';

type HookProps = {
  authorizationService?: AuthorizationServiceRequest;
};

type ExecuteProps = {
  authorizationService: Successful<AuthorizationServiceRequest>;
};

export function usePermissions({ authorizationService }: HookProps) {
  const request = useAxios(
    (axios, signal, { authorizationService }: ExecuteProps) => {
      if (!authorizationService.response.data._links.permissions)
        throw new Forbidden();

      const url = urlTemplate
        .parse(authorizationService.response.data._links.permissions.href)
        .expand({});

      return axios.request<PermissionsResponse>({
        signal,
        url,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!authorizationService?.response) return;
    request.execute({ authorizationService });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorizationService?.response]);

  if (!authorizationService) return;

  return request;
}

export type PermissionsRequest = ReturnType<typeof usePermissions>;
